import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {sumBy} from 'lodash';
  
const valueIfNull = '0';

class DataTable extends Component {
  renderObjectiveJapanPercent = (clientTmp, objectiveJapan, totalSales) => {
    if (clientTmp === '' || clientTmp === 'all') {
      const value = objectiveJapan && objectiveJapan !== 0 ?
        +((totalSales / objectiveJapan) * 100).toFixed(2) : valueIfNull;
      return `${value} %`;
    }
    return '---';
  }

  renderObjectiveJapan = (clientTmp, objectiveJapan) => {
    if (clientTmp === '' || clientTmp === 'all') {
      return objectiveJapan ? objectiveJapan : valueIfNull;
    }
    return '---';
  }
  
  renderLoaderOrSales = () => {
    const {loadingModels, loadingSales} = this.props;

    if (loadingModels || loadingSales) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation = () => {
    const {showDefaultValues, models, sales, clientTmp} = this.props;
    const data = showDefaultValues ? models : sales;

    return data.map((record, index) => {
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell collapsing className='lightgray-bg'>
            {showDefaultValues ? record.name : record.vehicleModelName}
          </Table.Cell>
          <Table.Cell>{record.vehicleReserve || valueIfNull}</Table.Cell>
          <Table.Cell>{record.vehicleAssigned || valueIfNull}</Table.Cell>
          <Table.Cell>{record.vehicleQuotes || valueIfNull}</Table.Cell>
          <Table.Cell className='sales-blue'>
            {record.vehicleSales || valueIfNull}
          </Table.Cell>
          <Table.Cell>
            {record.vehicleQuotes ?
              `${getNumericValue((record.vehicleSales / record.vehicleQuotes) * 100, 2)}%` :
              `${valueIfNull}%`}
          </Table.Cell>
          <Table.Cell className='sales-blue'>
            {record.budget || valueIfNull}
          </Table.Cell>
          <Table.Cell>
            {record.budget ?
              `${getNumericValue((record.vehicleSales / record.budget) * 100, 2)}%` :
              `${valueIfNull}%`}
          </Table.Cell>
          <Table.Cell className='sales-blue'>
            {this.renderObjectiveJapan(clientTmp, record.objectiveJapan)}
          </Table.Cell>
          <Table.Cell>
            {this.renderObjectiveJapanPercent(
              clientTmp,
              record.objectiveJapan,
              record.vehicleSales
            )}
          </Table.Cell>
          <Table.Cell>{record.dealerStock || valueIfNull}</Table.Cell>
          <Table.Cell>{record.tdeReservedStock || valueIfNull}</Table.Cell>
          <Table.Cell>{record.totalStock || valueIfNull}</Table.Cell>
          <Table.Cell>{record.prioritizedStock || valueIfNull}</Table.Cell>
          <Table.Cell>{record.salesLast3Months || valueIfNull}</Table.Cell>
          <Table.Cell>
            {record.salesLast3Months ?
              getNumericValue(record.totalStock / record.salesLast3Months, 2) :
              valueIfNull}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals = () => {
    const {
      loadingModels,
      loadingSales,
      showDefaultValues,
      models,
      sales,
      clientTmp,
    } = this.props;
    const data = showDefaultValues ? models : sales;

    if (loadingModels || loadingSales) {
      return null;
    }

    const totalQuotes = sumBy(data, 'vehicleQuotes');
    const totalSales = sumBy(data, 'vehicleSales');
    const totalBudget = sumBy(data, 'budget');

    const totalDealerStock = sumBy(data, 'dealerStock');
    const totalTdeReservedStock = sumBy(data, 'tdeReservedStock');
    const totalStock = sumBy(data, 'totalStock');
    const totalPrioritizedStock = sumBy(data, 'prioritizedStock');

    const totalSalesLast3Months = sumBy(data, 'salesLast3Months');
    const totalObjectiveJapan = sumBy(data, 'objectiveJapan');

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell className='lightgray-bg'>Total</Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {sumBy(data, 'vehicleReserve') || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {sumBy(data, 'vehicleAssigned') || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalQuotes || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalSales || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalQuotes ?
              `${getNumericValue((totalSales / totalQuotes) * 100, 2)}%` :
              `${valueIfNull}%`}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalBudget || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalBudget ?
              `${getNumericValue((totalSales / totalBudget) * 100, 2)}%` :
              `${valueIfNull}%`}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {this.renderObjectiveJapan(clientTmp, totalObjectiveJapan)}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {this.renderObjectiveJapanPercent(
              clientTmp,
              totalObjectiveJapan,
              totalSales
            )}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalDealerStock || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalTdeReservedStock || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalStock || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalPrioritizedStock || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {getNumericValue(totalSalesLast3Months, 2) || valueIfNull}
          </Table.HeaderCell>
          <Table.HeaderCell className='lightgray-bg'>
            {totalSalesLast3Months ?
              getNumericValue(totalStock / totalSalesLast3Months, 2) :
              valueIfNull}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card raised fluid>
        <Table className='gray-table'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='lightgray-bg'>
                Modelos
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Reservas
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Asignación
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Cotizaciones
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Ventas
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Tasa Cierre
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Objetivo Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                % Cumplimiento Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Objetivo Japón
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                % Cumplimiento TG Japón
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Stock Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Stock en TDE
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Stock Total
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Priorizados en TDE
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Promedio Ventas 3 meses
              </Table.HeaderCell>
              <Table.HeaderCell className='lightgray-bg'>
                Meses de Stock
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderOrSales()}</Table.Body>

          {this.renderTotals()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingModels': state.vehiclesModels.loading,
    'models': state.vehiclesModels.vehicles,
    'loadingSales': state.dailyVehiclesSalesAndStock.loadingSales,
    'sales': state.dailyVehiclesSalesAndStock.salesList,
  };
};

export default connect(mapStateToProps, {
})(DataTable);
